module.exports = __webpack_public_path__ + "img/achcu-icon-01.8e8cb229.svg";